export default "__VITE_ASSET__C6$HyvD6__"